import { StepStatus } from '@gjensidige/core-step-indicators/lib';

import { ROUTES } from '../lib/constants';
import {
  CHANNELS,
  HEADER_CONSTANTS,
  PRODUCTS,
  PRODUCT_CHANNELS,
  SESSION_KEYS
} from '../lib/constants/appConstants';
import { Offer, Package } from '../interfaces/Types';
import { AppConstants } from './AppConstants';
import { getPriceWithoutDiscount } from './Calculation/CalculationService';
import { InsuranceHelper } from './InsuranceHelper';

export class TextHelper {
  static getPageTitle = (product: string, page: string) => {
    const channelInfo = InsuranceHelper.getChannelInfo();
    let pageTitle = '';
    switch (product) {
      case PRODUCTS.CAR:
        if (page === ROUTES.offerPage) {
          pageTitle = 'Se ditt pris på bilförsäkring | Gjensidige';
        }
        else if (page === ROUTES.summaryPage) {
          pageTitle = 'Summering av din bilförsäkring | Gjensidige';
        }
        break;
      case PRODUCTS.MOPED:
        if (page === ROUTES.offerPage) {
          pageTitle = 'Se ditt pris på mopedforsakring | Gjensidige';
        }
        else if (page === ROUTES.summaryPage) {
          pageTitle = 'Summering av din mopedforsakring | Gjensidige';
        }
        break;
      case PRODUCTS.MC:
        if (page === ROUTES.offerPage) {
          pageTitle = 'Se ditt pris på motorcykelförsäkring | Gjensidige';
        }
        else if (page === ROUTES.summaryPage) {
          pageTitle = 'Summering av din motorcykelförsäkring | Gjensidige';
        }
        break;
      case PRODUCTS.ACCIDENT:
        if (page === ROUTES.offerPage) {
          pageTitle = 'Se ditt pris på olycksfalls­försäkring | Gjensidige';
        }
        break;
      case PRODUCTS.HOME:
        if (page === ROUTES.moreInputsPage) {
          pageTitle = `Uppgifter för din hemförsäkring | ${channelInfo}`;
        } else if (page === ROUTES.offerPage) {
          pageTitle = `Se ditt pris på hemförsäkring | ${channelInfo}`;
        } else if (page === ROUTES.summaryPage) {
          pageTitle = `Summering av din hemförsäkring | ${channelInfo}`;
        }
        break;
      case PRODUCTS.VILLA:
        if (page === ROUTES.moreInputsPage) {
          pageTitle = `Uppgifter för din villahemförsäkring | ${channelInfo}`;
        } else if (page === ROUTES.offerPage) {
          pageTitle = `Se ditt pris på villahemförsäkring | ${channelInfo}`;
        } else if (page === ROUTES.summaryPage) {
          pageTitle = `Summering av din villahemförsäkring | ${channelInfo}`;
        }
        break;
      case PRODUCTS.PPI:
        if (page === ROUTES.offerPage) {
          pageTitle = 'Se ditt pris på trygghetsförsäkring | Gjensidige';
        }
        break;
    }
    return pageTitle;
  };

  static getPageHeaderTitle = (product: string) => {
    let pageHeaderTitle = '';
    switch (product) {
      case PRODUCTS.CAR:
        pageHeaderTitle = AppConstants.getAppText('webshop.car.pageHeader');
        break;
      case PRODUCTS.MC:
        pageHeaderTitle = AppConstants.getAppText('webshop.mc.pageHeader');
        break;
      case PRODUCTS.MOPED:
        pageHeaderTitle = AppConstants.getAppText('webshop.moped.pageHeader');
        break;
      case PRODUCTS.HOME:
        pageHeaderTitle = AppConstants.getAppText('webshop.home.pageHeader');
        break;
      case PRODUCTS.VILLA:
        pageHeaderTitle = AppConstants.getAppText('webshop.villa.pageHeader');
        break;
      case PRODUCTS.ACCIDENT:
        pageHeaderTitle = AppConstants.getAppText('webshop.accident.pageHeader');
        break;
      case PRODUCTS.PPI:
        pageHeaderTitle = AppConstants.getAppText('webshop.ppi.pageHeader');
    }
    return pageHeaderTitle;
  };

  static getMoreInfoBannerText = (product: string) => {
    let pageHeaderTitle = '';
    switch (product) {
      case PRODUCTS.MC: {
        pageHeaderTitle = AppConstants.getAppText(
          'webshop.mc.moreInfoHeader'
        );
        break;
      }
      case PRODUCTS.HOME:
        pageHeaderTitle = AppConstants.getAppText(
          'webshop.home.moreInfoHeader'
        );
        break;
      case PRODUCTS.VILLA:
        pageHeaderTitle = AppConstants.getAppText(
          'webshop.villa.moreInfoHeader'
        );
        break;
    }
    return pageHeaderTitle;
  };

  static getPageDescription = (
    product: string,
    page: string,
    customerName: string
  ) => {
    let pageDescription = '';
    const customerGreetingText = customerName
      ? `${AppConstants.getAppText(
        'webshop.customerGreeting'
      )} ${customerName}!`
      : '';
    switch (product) {
      case PRODUCTS.CAR:
        if (page === ROUTES.offerPage) {
          pageDescription = `${customerGreetingText} \n ${AppConstants.getAppText(
            'webshop.car.pageDescription'
          )}`;
        }
        break;
      case PRODUCTS.MOPED:
        if (page === ROUTES.offerPage) {
          pageDescription = `${customerGreetingText} \n ${AppConstants.getAppText(
            'webshop.moped.pageDescription'
          )}`;
        }
        break;
      case PRODUCTS.MC:
        pageDescription = `${customerGreetingText} \n ${AppConstants.getAppText(
          'webshop.mc.pageDescription'
        )}`;
        break;
      case PRODUCTS.HOME:
        pageDescription = `${customerGreetingText} \n ${AppConstants.getAppText(
          'webshop.home.pageDescription'
        )}`;
        break;
      case PRODUCTS.VILLA:
        pageDescription = `${customerGreetingText} \n ${AppConstants.getAppText(
          'webshop.villa.pageDescription'
        )}`;
        break;
      case PRODUCTS.ACCIDENT:
        pageDescription = `${customerGreetingText} ${AppConstants.getAppText(
          'webshop.accident.pageDescription'
        )}`;
        break;
      case PRODUCTS.PPI:
        pageDescription = `${customerGreetingText} ${AppConstants.getAppText(
          'webshop.ppi.pageDescription'
        )}`;
        break;
    }
    return pageDescription;
  };

  static getObjectDescription = (product: string, offerDetails: Offer, page: string) => {
    const objectDescription: string[] = [];
    const customerInfo = JSON.parse(
      sessionStorage.getItem(SESSION_KEYS.CUSTOMER_INFO) || '{}'
    );
    switch (product) {
      case PRODUCTS.CAR:
      case PRODUCTS.MOPED:
        objectDescription.push(offerDetails.objectDescription);
        break;

      case PRODUCTS.HOME:
        objectDescription.push(
          `${customerInfo?.customerAddress ? customerInfo.customerAddress : ''
          }${customerInfo?.zipCode
            ? `, ${TextHelper.formatZipCode(customerInfo.zipCode)}`
            : ''
          }`
        );
        break;
      case PRODUCTS.MC:
        if (page === ROUTES.offerPage) {
          objectDescription.push(offerDetails?.objectDescription || '');
        } else {
          objectDescription.push(customerInfo?.registrationNumber ? customerInfo.registrationNumber : '');
        }
        break;
      case PRODUCTS.VILLA: {
        objectDescription.push(customerInfo?.propertyId ? customerInfo.propertyId : '');
        objectDescription.push(
          `${customerInfo?.customerAddress ? customerInfo.customerAddress : ''
          }${customerInfo?.zipCode
            ? `, ${TextHelper.formatZipCode(customerInfo.zipCode)}`
            : ''
          }`
        );
        break;
      }
    }
    return objectDescription;
  };

  static createStepLabel = (
    description: string,
  ) => {
    return { description };
  };

  static getHeaderStepLabels = (productName: string, page: string) => {
    const isCarOrMoped = productName === PRODUCTS.CAR || productName === PRODUCTS.MOPED;
    const stepLabelsMap = {
      [ROUTES.offerPage]: {
        [PRODUCTS.ACCIDENT]: {
          steps: [
            TextHelper.createStepLabel(AppConstants.getAppText('webshop.firstStepperLabel') || ''),
            TextHelper.createStepLabel(AppConstants.getAppText('webshop.accident.secondStepperLabel') || '')
          ],
          value: 0,
        },
        [PRODUCTS.PPI]: {
          steps: [
            TextHelper.createStepLabel(AppConstants.getAppText('webshop.firstStepperLabel') || ''),
            TextHelper.createStepLabel(AppConstants.getAppText('webshop.ppi.secondStepperLabel') || '')
          ],
          value: 0,
        },
        default: {
          steps: [
            TextHelper.createStepLabel(
              isCarOrMoped ? AppConstants.getAppText('webshop.firstStepperLabel') : ''
            ),
            TextHelper.createStepLabel(
              isCarOrMoped ? '' : AppConstants.getAppText('webshop.firstStepperLabel')
            ),
            ...(isCarOrMoped ? [] : [TextHelper.createStepLabel('')]),
            TextHelper.createStepLabel(''),
          ],
          value: isCarOrMoped ? 0 : 1,
        },
      },
      [ROUTES.moreInputsPage]: {
        default: {
          steps: [
            TextHelper.createStepLabel(AppConstants.getAppText('webshop.secondStepperLabel')),
            TextHelper.createStepLabel(''),
            TextHelper.createStepLabel(''),
            TextHelper.createStepLabel(''),
          ],
          value: 0
        }
      },
      [ROUTES.summaryPage]: {
        default: {
          steps: [
            TextHelper.createStepLabel(''),
            ...(isCarOrMoped ? [] : [TextHelper.createStepLabel('')]),
            TextHelper.createStepLabel('Summering'),
            TextHelper.createStepLabel(''),
          ],
          value: isCarOrMoped ? 1 : 2,
        }
      },
    };
    return stepLabelsMap[page][productName] || stepLabelsMap[page].default || {};
  };

  static getThirdRowText = (product: string, page: string) => {
    let thirdRowText = '';
    const customerInfo = JSON.parse(
      sessionStorage.getItem(SESSION_KEYS.CUSTOMER_INFO) || '{}'
    );
    if (product === PRODUCTS.CAR || product === PRODUCTS.MOPED || (product === PRODUCTS.MC && page === ROUTES.offerPage)) {
      thirdRowText = (customerInfo && customerInfo.registrationNumber) || '';
    }
    return thirdRowText;
  };

  static getPreviousPriceText = (campaignDiscountPercentages: number[], price: number) => {
    return campaignDiscountPercentages.length > 0
      ? TextHelper.thousandSeparator(
        getPriceWithoutDiscount(price, campaignDiscountPercentages).toString()
      )
      : '';
  }


  static getPackageHeaderLabels = (
    product: string,
    data: Package,
    campaignDiscountPercentages: number[]
  ) => {
    let headerData = {
      packageTitle: '',
      priceLabel: '',
      oldPriceLabel: '',
      packageInfos: ['']
    };
    // let priceBeforeCampaign = 0;
    // if (campaignDiscountPercentages.length > 0) {
    //   priceBeforeCampaign = getPriceWithoutDiscount(
    //     parseInt(data.monthlyPrice),
    //     campaignDiscountPercentages
    //   );
    // };
    const formattedMonthlyPrice = TextHelper.thousandSeparator(
      data.monthlyPrice
    );
    const FormattedPriceBeforeCampaign = TextHelper.getPreviousPriceText(campaignDiscountPercentages, parseInt(data.monthlyPrice));


    switch (product) {
      case PRODUCTS.CAR:
      case PRODUCTS.MC:
      case PRODUCTS.MOPED:
        headerData = {
          packageTitle: data.packageName,
          priceLabel: `${formattedMonthlyPrice} ${data.currency}/mån`,
          oldPriceLabel:
            campaignDiscountPercentages.length > 0
              ? data.monthlyPrice
                ? `${FormattedPriceBeforeCampaign} ${data.currency}/mån`
                : '-'
              : '',
          packageInfos: [``]
        };
        break;
      case PRODUCTS.HOME:
      case PRODUCTS.VILLA:
        headerData = {
          packageTitle:
            (!data.isPlusPackage
              ? data.packageName
              : data.packageHeaderLabel) || '',
          priceLabel: `${formattedMonthlyPrice} ${data.currency}/mån`,
          oldPriceLabel:
            campaignDiscountPercentages.length > 0
              ? data.monthlyPrice
                ? `${FormattedPriceBeforeCampaign} ${data.currency}/mån`
                : '-'
              : '',
          packageInfos: !data.isPlusPackage
            ? product === PRODUCTS.VILLA
              ? [
                data.deductibleInfo,
                data.secondaryDeductibleInfo,
                data.totalCoverageInfo
              ]
              : [
                data.totalCoverageInfo,
                data.deductibleInfo,
                data.secondaryDeductibleInfo
              ]
            : ['']
        };
        break;
    }
    return headerData;
  };

  static getSmallScreenPackageHeaderLabels = (
    product: string,
    data: Package,
    campaignDiscountPercentages: number[]
  ) => {
    let headerData = {
      packageTitle: '',
      priceLabel: '',
      oldPriceLabel: '',
      packageInfos: [''],
      monthlyPrice: ''
    };
    let priceBeforeCampaign = 0;
    if (campaignDiscountPercentages.length > 0) {
      priceBeforeCampaign = getPriceWithoutDiscount(
        parseInt(data.monthlyPrice),
        campaignDiscountPercentages
      );
    }
    const formattedMonthlyPrice = TextHelper.thousandSeparator(
      data.monthlyPrice
    );
    const FormattedPriceBeforeCampaign = TextHelper.thousandSeparator(
      priceBeforeCampaign.toString()
    );
    switch (product) {
      case PRODUCTS.CAR:
      case PRODUCTS.MOPED:
      case PRODUCTS.MC:
        headerData = {
          packageTitle: data.packageName,
          monthlyPrice: data.monthlyPrice,
          priceLabel: `${formattedMonthlyPrice} ${data.currency}`,
          oldPriceLabel:
            priceBeforeCampaign > 0
              ? `${FormattedPriceBeforeCampaign} ${data.currency}/mån`
              : '',
          packageInfos: [data.detailText]
        };
        break;
      case PRODUCTS.HOME:
      case PRODUCTS.VILLA:
        headerData = {
          packageTitle:
            (!data.isPlusPackage
              ? data.packageName
              : data.packageHeaderLabel) || '',
          monthlyPrice: data.monthlyPrice,
          priceLabel: data.monthlyPrice
            ? `${formattedMonthlyPrice} ${data.currency}`
            : '',
          oldPriceLabel:
            priceBeforeCampaign > 0
              ? `${FormattedPriceBeforeCampaign} ${data.currency}/mån`
              : '',
          packageInfos: !data.isPlusPackage
            ? product === PRODUCTS.VILLA
              ? [
                data.deductibleInfo,
                data.secondaryDeductibleInfo,
                data.totalCoverageInfo,
                data.detailText
              ]
              : [
                data.totalCoverageInfo,
                data.deductibleInfo,
                data.secondaryDeductibleInfo,
                data.detailText
              ]
            : [data.packageHeaderDetails || '']
        };
        break;
    }
    return headerData;
  };

  static getSmallScreenCoverageDetailsTexts = (
    product: string,
    data: Package
  ) => {
    let coverageText = '';
    switch (product) {
      case PRODUCTS.CAR:
      case PRODUCTS.MC:
      case PRODUCTS.MOPED:
        coverageText = data.detailText || '';
        break;
      case PRODUCTS.HOME:
        coverageText = !data.isPlusPackage
          ? data.detailText || ''
          : data.detailTextSmallScreen || '';
        break;
    }
    return coverageText;
  };

  static getAdditionalPackageDescription = (product: string) => {
    switch (product) {
      case PRODUCTS.CAR:
        return AppConstants.getAppText('webshop.additionalPackage.description');
      case PRODUCTS.HOME:
        return AppConstants.getAppText('webshop.home.additionalPackage.description');
      default:
        return '';
    }
  };

  static getPropertyDataMessage = (noOfProperties: number) => {
    return noOfProperties && noOfProperties > 1
      ? AppConstants.getAppText(
        'webshop.villa.propertyData.multiplePropertyModalMessage'
      )
      : AppConstants.getAppText('webshop.villa.propertyData.modalMessage');
  };

  static getCustomerCareNumber = (channel: string) => {
    switch (channel) {
      case CHANNELS.GJENSIDIGE:
        return HEADER_CONSTANTS.CUSTOMER_CARE_NUMBER;
      case CHANNELS.HGF:
      case CHANNELS.HGF_PPI:
        return HEADER_CONSTANTS.HGF_CUSTOMER_CARE_NUMBER;
      case CHANNELS.RIKSHEM:
        return HEADER_CONSTANTS.RIKSHEM_CUSTOMER_CARE_NUMBER;
      default:
        return '';
    }
  };

  static customerServiceLink = '<a href="https://www.gjensidige.se/privat/kundservice" target="_blank">Kontakta kundservice</a>';

  static customerServiceLinkHgf = '<a href="https://www.gjensidige.se/partners/hyresgastforeningen/kontakt" target="_blank">Kontakta kundservice</a>';

  static customerServiceLinkRikshem = '<a href="https://www.gjensidige.se/partners/rikshem-kontakt" target="_blank">Kontakta kundservice</a>';

  static getAreaValidationMessage = (productChannel: string, isLower: boolean) => {
    switch (productChannel) {
      case PRODUCT_CHANNELS.HOME_GJENSIDIGE:
        return isLower
          ? `Storleken på ditt hem är mindre än 20 m². ${TextHelper.customerServiceLink} så hjälper vi dig.`
          : `Storleken på ditt hem överstiger 200 m². ${TextHelper.customerServiceLink} så hjälper vi dig.`
      case PRODUCT_CHANNELS.HOME_HGF:
        return isLower
          ? `Storleken på ditt hem är mindre än 20 m². ${TextHelper.customerServiceLinkHgf} så hjälper vi dig.`
          : `Storleken på ditt hem överstiger 200 m². ${TextHelper.customerServiceLinkHgf} så hjälper vi dig.`
      case PRODUCT_CHANNELS.HOME_RIKSHEM:
        return isLower
          ? `Storleken på ditt hem är mindre än 1 m². ${TextHelper.customerServiceLinkRikshem} så hjälper vi dig.`
          : `Storleken på ditt hem överstiger 200 m². ${TextHelper.customerServiceLinkRikshem} så hjälper vi dig.`
      case PRODUCT_CHANNELS.VILLA_GJENSIDIGE:
        return isLower
          ? `Storleken på ditt hem är mindre än 50 m². ${TextHelper.customerServiceLink} så hjälper vi dig.`
          : `Storleken på ditt hem överstiger 300 m². ${TextHelper.customerServiceLink} så hjälper vi dig.`
      default:
        return '';
    }
  };

  static getNumberOfPeopleValidationMessage = (productChannel: string) => {
    switch (productChannel) {
      case PRODUCT_CHANNELS.HOME_GJENSIDIGE:
      case PRODUCT_CHANNELS.VILLA_GJENSIDIGE:
      case PRODUCT_CHANNELS.HOME_RIKSHEM:
        return `Vi kan inte försäkra fler än 6 personer via hemsidan. ${TextHelper.customerServiceLinkRikshem} så hjälper vi dig.`
      case PRODUCT_CHANNELS.HOME_HGF:
        return `Vi kan inte försäkra fler än 6 personer via hemsidan. ${TextHelper.customerServiceLinkHgf} så hjälper vi dig.`
      default:
        return `Vi kan inte försäkra fler än 6 personer via hemsidan. ${TextHelper.customerServiceLink} så hjälper vi dig.`
    }
  }

  static getBuiltYearValidationMessage = (
    product: string,
    isLower: boolean,
    minYear?: number
  ) => {
    switch (product) {
      case PRODUCTS.VILLA:
        return isLower
          ? `Byggnadsår måste vara senare än ${minYear}. ${TextHelper.customerServiceLink} så hjälper vi dig.`
          : AppConstants.getAppText(
            'webshop.villa.constructionYearFutureDateValidation'
          );
      default:
        return '';
    }
  };

  static formatZipCode = (zipCode: string) => {
    if (zipCode.split('').length !== 5) {
      return zipCode;
    }

    return zipCode.replace(/^(.{3})(.*)$/, '$1 $2');
  };

  static thousandSeparator = (number: string | number) => {
    if (typeof number === 'number') {
      number = number.toString();
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    if (!number) {
      return number;
    }

    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  static getWelcomeBackMessage = (redirectPage: string) => {
    if (redirectPage === ROUTES.summaryPage) {
      return {
        header: AppConstants.getAppText(
          'webshop.summary.welcome.welcomeBackHeader'
        ),
        message: AppConstants.getAppText(
          'webshop.summary.welcome.welcomeBackPageInfo'
        )
      };
    }
    return {
      header: 'Välkommen',
      message: 'För att du ska kunna se ditt pris måste du identifiera dig med BankID.'
    };
  }

}
